import clsx from 'clsx';
import logotypeVertical from '@assets/images/logo/logotype-vertical.png';
import { Grid, Typography, withStyles } from '@material-ui/core';

import ButtonContained from '$app-web/components/button-contained';
import { keyExists, t } from '$app-web/i18n';
import LayoutFull from '$app-web/layouts/full';

import styles, { LoadingIndicator } from './styles';

interface Props {
    classes: Record<string, string>;
    errorButtonClick?: () => void;
    errorButtonText?: string;
    hasBackground?: boolean;
    hideLogo?: boolean;
    hasError?: boolean;
}

const FullLoadingIndicator = ({
    classes,
    errorButtonClick = () => {
        window.location.reload();
    },
    errorButtonText = 'Reload',
    hasBackground = true,
    hideLogo = false,
    hasError = false,
}: Props) => {
    return (
        <LayoutFull
            content={
                <Grid
                    container
                    spacing={0}
                    direction="row"
                    justify="center"
                    className={clsx(classes.root, {
                        [classes.background]: hasBackground,
                    })}
                >
                    <Grid container direction="column" spacing={0} justify="center" wrap="nowrap" className={classes.mainWrapper}>
                        {!hideLogo && (
                            <Grid item>
                                <img src={logotypeVertical} alt="Avicenna Research logo" className={classes.logoImage} />
                            </Grid>
                        )}
                        {!hasError && (
                            <Grid item>
                                <LoadingIndicator className={hasError ? classes.hide : undefined} />
                            </Grid>
                        )}
                        {hasError && (
                            <Grid item>
                                <Typography variant="body2" color="error">
                                    {keyExists('generic_error_msg') ? t('generic_error_msg') : 'Sorry, something went wrong.'}
                                </Typography>
                                <ButtonContained
                                    text={errorButtonText}
                                    color="error"
                                    handleClick={errorButtonClick}
                                    className={classes.button}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            }
        />
    );
};

// @ts-expect-error: Should be replaced after UI refactoring
export default withStyles(styles)(FullLoadingIndicator);
